import React from "react";
import { securebg } from "./../../Public/assets/index.js";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

function SecureYourMoney() {
  const navigate = useNavigate();
  return (
    <div className=" xl:mx-[134px] shadow-secureBg !bg-[#D0EBFF] rounded-3xl  mx-6 lg:mx-[84px] text-center my-16 lg:mt-[37px] lg:mb-[160px]">
      <div className=" order-2 lg:order-1 flex justify-center mb-2 lg:mb-6  px-8  pt-8">
        <img
          src={securebg}
          alt=""
          className="w-[202px] lg:w-[290px] h-[160px] lg:h-[280px]"
        />
      </div>
      <div className="order-1 lg:order-2 p-2  pb-8 lg:px-8 xl:pb-[56px] ">
        <h1 className="text-[28px] w-[95%]  lg:text-[52px] font-[400] leading-[42px] lg:leading-[65px] xl:w-[717px] mx-auto text-[#162542] font-IvyJournal mb-4 ">
          We've partnered with the best to <br />
          <span className="text-blueish  text-[28px] font-IvyJournal font-[600] leading-[42px] lg:leading-[65px] lg:text-[52px]">
            secure your money
          </span>
        </h1>

        <p className="m-auto  w-[95%] text-[#162542] text-center lg:w-[595px] font-geomanistRegular text-[16px] md:text-[12px] lg:text-[14px] xl:text-[18px] lg:leading-[25px] font-[400] mb-[17px]">
          Your multi-currency account will be held in{" "}
          <span className="font-geomanistBold font-[500] text-[16px] md:text-[12px] lg:text-[14px] xl:text-[18px] ">
            Singapore
          </span>{" "}
          with one of the largest banks in the world
        </p>

        <div className="mt-4 mb-4 lg:mt-[29px] flex justify-center">
          <button
            className="group relative text-[11px] md:text-xl lg:text-xl font-normal leading-[12px] md:leading-6 font- text-white rounded-[5px] bg-blueish py-2.5 xxl:py-3 px-[13px] xxl:px-5 flex items-center overflow-hidden transition-all duration-700 ease-in-out hover:px-7 max-w-fit font-geomanistMedium"
            onClick={() => {
              navigate("/contact");
            }}
          >
            Talk to our expert to know more
            <div className="w-0 overflow-hidden transition-all duration-500 ease-in-out group-hover:w-6 md:group-hover:w-8">
              <ArrowRight className="w-[16px] md:w-[24px] h-[16px] md:h-[24px] opacity-0 translate-x-[-10px] transition-all duration-700 ease-in-out group-hover:opacity-100 group-hover:translate-x-0 group-hover:ml-2 font-geomanistMedium" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default SecureYourMoney;
